import { ITaskPriorityEditItem, TaskPriorityEditItem } from "./taskPriorityEditItem";

export interface ITaskPriorityEdit {
    item: ITaskPriorityEditItem;
}

export class TaskPriorityEdit implements ITaskPriorityEdit {
    item: TaskPriorityEditItem;

    constructor();
    constructor(obj: ITaskPriorityEdit);
    constructor(obj?: any) {
        this.item = new TaskPriorityEditItem(obj ? obj.item : null);
    }
}